export default __webpack_public_path__ + "static/media/twitter.4d5b4ef9.svg";